// FassalkartAI - Company (B2B) Protected Route

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../ui/LoadingScreen';

/**
 * Allows access only to users with role === 'company'.
 */
const CompanyRoute = ({ children }) => {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) return <LoadingScreen message="Loading B2B portal..." />;

  if (!currentUser) return <Navigate to="/company/login" replace />;

  if (userProfile?.role !== 'company') return <Navigate to="/dashboard" replace />;

  return children;
};

export default CompanyRoute;
